import { render, staticRenderFns } from "./CustomerSelector.vue?vue&type=template&id=85c65358&"
import script from "./CustomerSelector.vue?vue&type=script&lang=js&"
export * from "./CustomerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports